import { isExportDatasetKey } from "./constants";
import type { EntityExportSelection, ExportRequestPayload } from "./types";

/**
 * Builds the export request payload from modal selection.
 * Keeps only known dataset keys (guards against stale or invalid state).
 * Pure function: no I/O.
 */
export function buildExportPayload(
  selection: EntityExportSelection,
): ExportRequestPayload {
  const validDatasets = selection.datasets.filter(isExportDatasetKey);
  return {
    entityIds: [...selection.entityIds],
    datasets: [...validDatasets],
  };
}
